import { View } from 'react-native'

/**
 * This view needs to be mocked in tests since we need to mock `measureInWindow` on its ref.
 */
export const AutocompleteContainerView = View
